import React from 'react';

export const OCContext = React.createContext(false);